import styled from '@emotion/styled';
import { Variables } from '../base/variables/variables';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 24px 12px;
    min-width: 600px;
    max-width: 720px;
`;

export const Intro = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 1.45;
    color: ${Variables.ThemeLight.TextMedium};
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const FieldLabel = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const Option = styled.span`
    display: flex;
    flex-direction: column;
    font-weight: 500;
`;

/** A clearinghouse option's second line, in the open picker. */
export const OptionInfo = styled.span`
    margin-top: 2px;
    font-weight: 400;
    font-size: 12px;
    color: ${Variables.ThemeLight.TextMild};
`;

/** What the check recognised the file as — confirmation, not an alert. */
export const Recognised = styled.div`
    margin-top: -8px;
    font-size: 13px;
    color: ${Variables.ThemeLight.TextMild};
`;

export const Payments = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${Variables.ThemeLight.Border1};
    border-radius: 8px;
`;

export const Payment = styled.div`
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr 1fr 1.6fr;
    gap: 12px;
    padding: 10px 14px;
    font-size: 13px;
    color: ${Variables.ThemeLight.TextMedium};

    & + & {
        border-top: 1px solid ${Variables.ThemeLight.Border1};
    }
`;

export const PaymentHeader = styled(Payment)`
    color: ${Variables.ThemeLight.TextMild};
    background: ${Variables.ThemeLight.Background1};
    border-radius: 8px 8px 0 0;
`;

/** Amounts and trace numbers must not wrap mid-number. */
export const Mono = styled.span`
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
`;

/** The duplicate-upload caution. Pale surface, dark foreground — the NS-2 warning pair. */
export const Caution = styled.div`
    padding: 10px 14px;
    border-radius: 8px;
    background: ${Variables.ThemeLight.AttentionMild3};
    color: ${Variables.ThemeLight.AttentionInverted3};
    font-size: 13px;
    line-height: 1.45;
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 8px;
`;
